<template>
  <div class="details-container">
    <b-row>
      <!-- Row -->
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'ordering_information' | i18n }}:</span>
      </b-col>
      <b-col
        sm="3"
        class="details-column"
      >
        {{ row.item.details }}
      </b-col>
      <b-col
        sm="1"
        class="details-column text-sm-right"
      >
        <span>{{ 'customer_name' | i18n }}:</span>
      </b-col>
      <b-col
        sm="3"
        class="details-column"
      >
        {{ row.item.address }}
      </b-col>
      <b-col
        sm="1"
        class="text-sm-right details-column action-column"
      >
        <span>{{ 'print' | i18n }}:</span>
      </b-col>
      <b-col
        sm="2"
        class="details-column"
      >
        <a
          variant="outline-primary"
          size="sm"
          class="btn-print mr-2"
          :href="appConfig.apiUrl + '/Auftragsverarbeitung/Print/' + row.item.id"
          target="_blank"
        >
          <img :src="withoutPictureIcon">
          {{ 'without_image' | i18n }}
        </a>
        <a
          variant="outline-primary"
          size="sm"
          class="btn-print"
          :href="appConfig.apiUrl + '/Auftragsverarbeitung/PrintWithPictures/' + row.item.id"
          target="_blank"
        >
          <img :src="withPictureIcon">
          {{ 'with_image' | i18n }}
        </a>
      </b-col>
      <!--/ Row END -->

      <!-- Row -->
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'order_reference' | i18n }}:</span>
      </b-col>
      <b-col
        sm="3"
        class="details-column"
      >
        {{ row.item.information2 }}
      </b-col>
      <b-col
        sm="1"
        class="details-column text-sm-right"
      >
        <span>{{ 'clerk_short' | i18n }}:</span>
      </b-col>
      <b-col
        sm="3"
        class="details-column"
      >
        {{ row.item.sb }}
      </b-col>
      <!--/ Row END -->

      <!-- Row -->
      <b-col
        sm="1"
        class="details-column text-sm-right"
      >
        <span>{{ 'matchcode' | i18n }}:</span>
      </b-col>
      <b-col sm="2">
        {{ row.item.matchcode }}
      </b-col>
      <!--/ Row END -->
    </b-row>
  </div>
</template>

<script>
import appConfig from '../../../app.config';
import withoutPictureIcon from '../../../assets/icons/blue/print_without_pictures_blue.svg';
import withPictureIcon from '../../../assets/icons/blue/print_with_pictures_blue.svg';
import {BRow, BCol} from 'bootstrap-vue';

export default {
  name: 'OrderTableDetailsRow',
  components: {'b-row': BRow, 'b-col': BCol},
  props: {
    row: {
      type: Object,
      default: () => {
      }
    }
  },
  data: function () {
    return {
      appConfig,
      withoutPictureIcon,
      withPictureIcon
    };
  }
};
</script>

<style scoped lang="scss">
  ::v-deep   .details-container {
    padding: 10px;
  }

  .details-column {
    padding-right: 8px !important;
    padding-left: 8px !important;
  }

  span {
    color: #7586A5;
  }

  .btn-print {
    display: inline-block;
  }
</style>
